import type { ReactNode } from 'react'
import { SectionKey, type PreviewZone } from '@/constants'
import { getPreviewFrame } from '@/utils/previewSlots'
import { usePreviewStore } from '@/stores/usePreviewStore'

interface PreviewSlotProps {
  uid: string | undefined
  sectionKey: SectionKey
  index: number
  zone: PreviewZone
  label?: string
  deletable?: boolean
  children: ReactNode
}

const PreviewSlot = ({ uid, sectionKey, index, zone, label, deletable = false, children }: PreviewSlotProps) => {
  const Frame = getPreviewFrame()
  const navigable = usePreviewStore(s => s.navigationEnabled) && sectionKey === SectionKey.NavigationalBlocks
  if (!Frame || !uid || navigable) {
    return <>{children}</>
  }
  return (
    // eslint-disable-next-line react-hooks/static-components -- Registry lookup of a module-level component; the compiler cannot see that it is stable across renders.
    <Frame
      uid={uid}
      sectionKey={sectionKey}
      index={index}
      zone={zone}
      label={label || sectionKey}
      deletable={deletable}>
      {children}
    </Frame>
  )
}

export default PreviewSlot
